import React from "react";
import "./Button.css";

function Button({
    id = "",
    type = 'button',
    className = "",
    kind = 'primary',
    disabled = false,
    small = false,
    big = false,
    fluid = false,
    inverse = false,
    ghost = false,
    asLink = false,
    target = '',
    openInNewTab = false,
    onClick = () => { },
    children }) {




    return asLink ? <a
        id={id}
        href={target}
        rel={openInNewTab ? 'noopener' : ''}
        target={openInNewTab ? '_blank' : ''}
        className={`${className} button ${kind} ${small ? "small" : ""} ${big ? "big" : ""} ${fluid ? "fluid" : ""} ${inverse ? "inverse" : ""} ${ghost ? "ghost" : ""}`}>{children}</a>
        :
        <button
            id={id}
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`${className} button ${kind} ${small ? "small" : ""} ${big ? "big" : ""} ${fluid ? "fluid" : ""} ${inverse ? "inverse" : ""} ${ghost ? "ghost" : ""}`}>{children}</button>
}

export default React.memo(Button);

